import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import APIService from "../../services/APIService";
import { useNavigate } from "react-router-dom";

const initState = {
  cartInfo: null,
  drugStoreID: 0,
  onModalCart: false,
};
export const cartSlice = createSlice({
  name: "cart",
  initialState: initState,
  reducers: {
    setModalCart: (state, action) => {
      state.onModalCart = action.payload;
    },
    saveCart: (state, action) => {
      state.cartInfo = action.payload;
      state.drugStoreID = action.payload[0]?.id;
    },
    saveDrugStore: (state, action) => {
      state.drugStoreID = action.payload;
    },
    clearCart: (state) => {
      state.cartInfo = undefined;
    },
  },
});

export async function fetchCart(dispatch, callback) {
  const RESULT = await APIService.getCart();
  if (RESULT.length == 0) {
    dispatch(setModalCart(false));
  }
  dispatch(saveCart(RESULT));
  callback && callback();
}

export async function updateNumber(dispatch, getState, data) {
  var state = JSON.parse(JSON.stringify(getState().cart));
  const RESULT = await APIService.updateNumberCart(
    data.quantity,
    data.unit_id,
    data.drug_id
  );
  if (RESULT) {
    state.cartInfo?.forEach((item) => {
      item.drugs.forEach((item) => {
        if (item.drug_id == data.drug_id && item.unit_id == data.unit_id) {
          item.quantity = data.quantity;
        }
      });
    });
  }
  dispatch(saveCart(state.cartInfo));
}

export async function deleteItem(dispatch, getState, data) {
  const RESULT = await APIService.deleleItemCart(data.unit_id, data.drug_id);
  if (RESULT) {
    fetchCart(dispatch);
  }
}

export async function addItem(dispatch, getState, data) {
  var state = JSON.parse(JSON.stringify(getState().cart));
  const checkExistsCart = state.cartInfo?.find(
    (item) => !!item.drugs.find((drug) => drug.drug_id == data.drug_id)
  );
  console.log(checkExistsCart);
  if (checkExistsCart) {
    dispatch(setModalCart(true));
    fetchCart(dispatch);
    return;
  }
  const RESULT = await APIService.addItemCart(
    data.drug_id,
    data.quantity,
    data.unit_id
  );
  if (RESULT) {
    dispatch(setModalCart(true));
    fetchCart(dispatch);
  }
}

export async function buyNow(dispatch, getState, data, callback) {
  var state = JSON.parse(JSON.stringify(getState().cart));
  const checkExistsCart = state.cartInfo?.find(
    (item) => !!item.drugs.find((drug) => drug.drug_id == data.drug_id)
  );
  console.log(checkExistsCart);
  if (checkExistsCart) {
    fetchCart(dispatch, callback);
    return;
  }
  const RESULT = await APIService.addItemCart(
    data.drug_id,

    data.quantity,
    data.unit_id
  );
  if (RESULT) {
    fetchCart(dispatch, callback);
  }
}

export const selectCart = (state) => state.cart.cartInfo;
export const selectDrugStore = (state) => state.cart.drugStoreID;
export const selectModalCart = (state) => state.cart.onModalCart;

export const selectCartWithStore = (state) => {
  const cartState = state.cart;
  var result = cartState.cartInfo?.find((x) => x.id === cartState.drugStoreID);
  return (result && result.drugs) || [];
};

export const selectPaymenMethodWithStore = (state) => {
  const cartState = state.cart;
  var result = cartState.cartInfo?.find((x) => x.id === cartState.drugStoreID);
  return (result && result.payments_method) || [];
};

export const selectCountCart = (state) => {
  const cartState = state.cart;
  var length = 0;
  cartState.cartInfo?.map((item) => {
    length += item.drugs.length;
  });
  return length;
};

export const {
  saveCart,
  saveDrugStore,
  clearCart,
  setModalCart,
  updateNumberCart,
} = cartSlice.actions;

export default cartSlice.reducer;
